/**
 * Readiness signal for Sentry integrations that are attached after startup.
 *
 * Replay and feedback are loaded on idle (see main.tsx) to keep them out of the
 * entry chunk. Anything that reads them - `Sentry.getFeedback()`, for instance -
 * therefore cannot assume they exist at mount time, so it awaits this instead.
 *
 * Resolves immediately in dev, where the deferred loader never runs.
 */
let markReady: (() => void) | undefined;

export const sentryIntegrationsReady = new Promise<void>((resolve) => {
  // Sentry is not initialised in dev, so nothing will ever signal - resolve now
  // rather than leaving consumers waiting on a promise that cannot settle.
  if (import.meta.env.DEV) resolve();
  else markReady = resolve;
});

/** Called by the deferred loader once the integrations are attached (or failed). */
export const notifySentryIntegrationsReady = (): void => markReady?.();
